// extracted by mini-css-extract-plugin
export var menuIcon = "_mv-0";
export var menuIconInline = "_mv-1";